module.exports = __webpack_public_path__ + "media/images/pages/img_living_01-5f7e601707ed1367a6d7cdf03e394495.jpg";